module.exports = __webpack_public_path__ + "f616527c652eba348f274217f77b69af.MP3";